// extracted by mini-css-extract-plugin
export default {"table":"style_table__nZWfh","header":"style_header__oxgUc","row":"style_row__wsaur","cell":"style_cell__rNB3u"};